import { Grid } from "@material-ui/core";
import { observer } from "mobx-react";
import * as React from "react";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from "react-i18next";
import GlobitsDateTimePicker from "app/common/form/GlobitsDateTimePicker";
import moment from "moment";
import GlobitsNumberInput from "app/common/form/GlobitsNumberInput";
import { VIEW_MONTHS_IF_UNDER_5_YEARS_OLD } from "app/appConfig";
import { toast } from "react-toastify";

function getAge(birthDate) {
  var today = new Date();
  var age = today.getFullYear() - new Date(birthDate)?.getFullYear();
  var m = today.getMonth() - new Date(birthDate)?.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < new Date(birthDate)?.getDate())) {
    age--;
  }
  if (age < 0) {
    return null;
  }
  return age;
}

function BirthDateAge({
  mdDate = 2,
  smDate = 3,
  xsDate = 6,
  mdAge = 2,
  smAge = 3,
  xsAge = 6,
  maxAge = 200,
  disabled,
  ...props
}) {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  const {
    nameSpaceDate,
    nameSpaceAge,
    valueDate,
    valueAge,
    setFieldValue,
    values,
  } = props;

  const withNameSpaceDate = (field) => {
    if (nameSpaceDate) {
      return `${nameSpaceDate}.${field}`;
    }
    return field;
  };

  const withNameSpaceAge = (field) => {
    if (nameSpaceAge) {
      return `${nameSpaceAge}.${field}`;
    }
    return field;
  };

  const [age, setAge] = React.useState(null);
  const [birthDate, setBirthDate] = React.useState(null);
  const [clear, setClear] = React.useState(undefined);

  function getAgeBirthDate() {
    setBirthDate(valueDate?.birthDate);
    setAge(valueAge?.age);
  }

  React.useEffect(() => {
    if (valueDate?.birthDate && !valueAge?.age) {
      setFieldValue(withNameSpaceAge("age"), getAge(valueDate?.birthDate));
      setAge(getAge(valueDate?.birthDate));
    } else {
      getAgeBirthDate();
    }
  }, [valueAge?.age, valueDate?.birthDate]);

  function handleChangeBirthDate(value) {
    setBirthDate(value);
    let age = null;
    const today = new Date();
    // Check if the selected date is in the future
    if (value && moment(value).isValid()) {
      if (moment(value).isAfter(today)) {
        // Show error message and set birthDate to null
        setFieldValue(withNameSpaceAge("age"), null);
        setFieldValue(withNameSpaceDate("birthDate"), null);
        setAge(null);
        toast.error("Ngày sinh không hợp lệ");
      } else {
        age = getAge(value);
        if (age >= 0) {
          setAge(age);
        } else {
          setAge(null);
        }
        setFieldValue(withNameSpaceAge("age"), age);
        setFieldValue(withNameSpaceDate("birthDate"), value);
      }
    } else {
      setAge("");
      setFieldValue(withNameSpaceAge("age"), "");
      setFieldValue(withNameSpaceDate("birthDate"), value);
    }
  }

  function handleChangeAge(event) {
    let value = event.target.value;
    setAge(value);
    let newBirthDate = null;
    if (birthDate) {
      let date = new Date(birthDate);
      newBirthDate = date.setFullYear(currentYear - value);
    } else {
      newBirthDate = new Date(currentYear - value, 0, 1);
    }
    setBirthDate(newBirthDate);
    if (clear) clearTimeout(clear);
    setClear(
      setTimeout(() => {
        setFieldValue(withNameSpaceAge("age"), value);
        // if (birthDate) {
        //   let date = new Date(birthDate);
        //   setFieldValue(withNameSpace('birthDate'), newBirthDate)
        // } else {
        setFieldValue(withNameSpaceDate("birthDate"), newBirthDate);
        // }
      }, 500)
    );
  }

  return (
    <>
      <Grid item md={mdDate} sm={smDate} xs={xsDate}>
        <GlobitsDateTimePicker
          //   disabled={!editable}
          label={t("patient.birthDate")}
          name={withNameSpaceDate("birthDate")}
          maxDateMessage="Ngày sinh phải trước ngày hiện tại"
          onChange={handleChangeBirthDate}
          value={birthDate ? birthDate : null}
          notDelay
          disabled={disabled}
          maxDate={new Date()}
          invalidDateMessage
          required={props.required}
        />
      </Grid>
      <Grid item md={mdAge} sm={smAge} xs={xsAge}>
        <GlobitsNumberInput
          //   disabled={!editable}
          label={t("patient.age")}
          maxValue={maxAge}
          name={withNameSpaceAge("age")}
          value={age >= 0 ? age : ""}
          onChange={handleChangeAge}
          notDelay
          disabled={disabled}
        />
      </Grid>
    </>
  );
}

export default observer(BirthDateAge);
